















































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import BasicSelect from '@/components/common/BasicSelect.vue';
import {
  ISubQuestionCondition,
  LOGICAL_OPERATORS,
  COMPARISON_TYPES,
  createDefaultCondition,
  getComparisonTypesByType,
} from '@/views/question/constants/sub-question';
import BaseInput from '@/components/common/BaseInput.vue';
import { cloneDeep } from 'lodash';
import { QUESTION_TYPES } from '@/views/question/constants';

@Component({
  components: {
    BasicSelect,
    BaseInput,
  },
})
export default class SubQuestionConditionModal extends Vue {
  @Prop({ default: () => [] }) initialConditions!: ISubQuestionCondition[];
  @Prop({ default: () => [] }) questionOptions!: any[];
  @Prop({ default: null }) questionId!: number | string | null;
  @Prop({ default: 'sub-question-condition' }) modalName!: string;
  @Prop({ default: '' }) parentQuestionType!: string;

  localConditions: ISubQuestionCondition[] = [];
  private snapshotConditions: ISubQuestionCondition[] = [];
  private isCommitted: boolean = false;

  get logicalOperators() {
    return LOGICAL_OPERATORS;
  }

  get comparisonTypes() {
    if (this.parentQuestionType) {
      return getComparisonTypesByType(this.parentQuestionType);
    }
    return COMPARISON_TYPES;
  }

  get isParentSelectable() {
    return this.questionOptions && this.questionOptions.length > 0;
  }

  get isLogicalOperatorDisabled() {
    const { RADIO } = QUESTION_TYPES;
    return [RADIO, 'pulldown'].includes(this.parentQuestionType as any);
  }

  get answerOptions() {
    return this.questionOptions.map((opt) => {
      // FIX: Correctly check for value existence to avoid object fallback on falsy values (0, "")
      const value = (typeof opt === 'object' && opt !== null && opt.value !== undefined)
        ? opt.value
        : opt;
      return {
        name: String(value),
        value,
      };
    });
  }

  get isValid(): boolean {
    if (!this.localConditions.length) {
      return true;
    }
    return this.localConditions.every((c) => {
      if (this.isNoValueOperator(c.comparison)) {
        return true;
      }
      if (this.isRangeOperator(c.comparison)) {
        const val = c.answer_value;
        return Array.isArray(val) && val[0] !== undefined && val[1] !== undefined && val[0] !== '' && val[1] !== '';
      }
      if (this.isMultipleSelection(c.comparison)) {
        return Array.isArray(c.answer_value) && c.answer_value.length > 0;
      }
      return c.answer_value !== '' && c.answer_value !== null && c.answer_value !== undefined;
    });
  }

  isSelectOperator(op: string) {
    return ['is', 'not_is', 'in', 'not_in'].includes(op);
  }

  isMultipleSelection(op: string) {
    const { CHECKBOX } = QUESTION_TYPES;
    return (
      this.parentQuestionType === CHECKBOX
      && ['in', 'not_in'].includes(op)
    );
  }

  isTextOperator(op: string) {
    return ['contains', 'not_contains', 'regex'].includes(op);
  }

  isNumericOperator(op: string) {
    return ['gt', 'gte', 'lt', 'lte', 'count_eq', 'count_gt', 'count_lt'].includes(op);
  }

  isRangeOperator(op: string) {
    return op === 'between';
  }

  isNoValueOperator(op: string) {
    return ['is_empty', 'is_not_empty'].includes(op);
  }

  getRangeValue(value: any, index: number) {
    if (Array.isArray(value)) {
      return value[index];
    }
    return '';
  }

  addCondition() {
    const targetId = this.questionId || '';
    const condition = createDefaultCondition(targetId);

    // For Radio/Pulldown, always use OR for subsequent conditions
    if (this.isLogicalOperatorDisabled) {
      condition.logical_operator = 'OR';
    }

    // Ensure default comparison is valid for parent question type
    if (this.comparisonTypes.length > 0) {
      const isValid = this.comparisonTypes.some((ct) => ct.value === condition.comparison);
      if (!isValid) {
        condition.comparison = this.comparisonTypes[0].value;
      }
    }

    this.localConditions.push(condition);
  }

  removeCondition(index: number) {
    this.localConditions.splice(index, 1);
  }

  updateCondition(index: number, field: string, value: any) {
    if (field === 'comparison') {
      // Reset answer_value when operator changes to avoid type mismatch
      let defaultValue: any = '';
      if (this.isMultipleSelection(value)) {
        defaultValue = [];
      }
      if (this.isRangeOperator(value)) {
        defaultValue = ['', ''];
      }
      if (this.isNoValueOperator(value)) {
        defaultValue = null;
      }
      this.$set(this.localConditions[index], 'answer_value', defaultValue);
    }
    this.$set(this.localConditions[index], field, value);
  }

  updateRange(index: number, rangeIndex: number, value: any) {
    const answerValue = this.localConditions[index].answer_value;
    const current = Array.isArray(answerValue)
      ? [...(answerValue as Array<string | number>)]
      : ['', ''];
    current[rangeIndex] = value;
    this.$set(this.localConditions[index], 'answer_value', current);
  }

  handleBeforeOpen() {
    this.isCommitted = false;
    this.snapshotConditions = this.initialConditions ? cloneDeep(this.initialConditions) : [];
    this.localConditions = cloneDeep(this.snapshotConditions);
  }

  handleBeforeClose() {
    if (!this.isCommitted) {
      this.localConditions = cloneDeep(this.snapshotConditions);
    }
  }

  handleSave() {
    this.isCommitted = true;
    this.$emit('onSave', cloneDeep(this.localConditions));
    this.$modal.hide(this.modalName);
  }

  handleCancel() {
    this.localConditions = cloneDeep(this.snapshotConditions);
    this.$emit('onCancel');
    this.$modal.hide(this.modalName);
  }
}
